import getSchedules from './getSchedules';
import getSchedulesHallApi from './getSchedulesHallApi';

export default {
  getSchedules,
  getSchedulesHallApi,
};
